import {
  Wrench,
  MailOpen,
  Trophy,
  PlayCircle,
  Gift,
  TrendingUp,
  Users,
  Video,
  BarChart3,
  Calculator,
  Sparkles,
  Mic,
  MessageSquare,
  Clock,
  type LucideIcon,
} from "lucide-react";
import type { UtilizationMethod } from "@/content/utilization";

const icons: LucideIcon[] = [
  Wrench,
  MailOpen,
  Trophy,
  PlayCircle,
  Gift,
  TrendingUp,
  Users,
  Video,
  BarChart3,
  Calculator,
  Sparkles,
  Mic,
  MessageSquare,
  Clock,
];

interface Props {
  methods: readonly UtilizationMethod[];
}

export function MomentumGrid({ methods }: Props) {
  return (
    <div className="grid auto-rows-fr gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {methods.map((method, i) => {
        const Icon = icons[i % icons.length];
        return (
          <article
            key={method.title}
            className="relative flex h-full flex-col overflow-hidden rounded-2xl border border-border/60 bg-background p-6 text-left"
          >
            <span
              aria-hidden
              className="pointer-events-none absolute -right-2 -top-6 select-none font-display text-[5.5rem] font-semibold leading-none text-primary/[0.07]"
            >
              {String(i + 1).padStart(2, "0")}
            </span>

            <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-primary/20 bg-primary/5 text-primary">
              <Icon className="h-5 w-5" strokeWidth={1.5} />
            </span>

            <h3
              className="relative mt-4 text-base font-semibold leading-snug text-ink"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              {method.title}
            </h3>

            <p className="relative mt-3 text-sm leading-relaxed text-muted-foreground">
              {method.body}
            </p>
          </article>
        );
      })}
    </div>
  );
}
